import { NavLink } from 'react-router'
import { FiArrowRight } from 'react-icons/fi'
import { Container, Reveal, HoverText } from '@/components/common'
import { ROUTES } from '@/constants/routes'
import magazineCover from '@/assets/images/magazine-feature.jpeg'
import { actionClass, actions } from '@/constants/magazine'

export const Magazine = () => {
  return (
    <section className="bg-white py-24 lg:py-32">
      <Container className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
        {/* Cover */}
        <Reveal variant="right" className="order-last lg:order-first">
          <div className="overflow-hidden">
            <img
              src={magazineCover}
              alt="IBON World Magazine, featured issue"
              className="aspect-4/5 w-full object-cover transition-transform duration-700 hover:scale-105"
              loading="lazy"
            />
          </div>
        </Reveal>

        {/* Text */}
        <div>
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.05] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Stories. Insights.{' '}
              <span className="text-ibon-dark/30">Ideas that inspire change.</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-8 max-w-xl text-lg leading-relaxed text-text-muted">
              IBON World Magazine is our platform for sharing the stories, perspectives, and
              innovations shaping the future of Africa and the Caribbean. Explore our latest edition
              and discover inspiring stories, emerging trends, and voices creating impact across the
              regions we serve.
            </p>
          </Reveal>

          <Reveal variant="up" delay={300}>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
              {actions.map(({ label, variant }) => (
                <NavLink key={label} to={ROUTES.MAGAZINE} className={actionClass[variant]}>
                  <HoverText text={label} />
                  <FiArrowRight
                    className="transition-transform duration-300 group-hover:translate-x-1"
                    size={15}
                  />
                </NavLink>
              ))}
            </div>
          </Reveal>

          <Reveal variant="fade" delay={380}>
            <p className="mt-6 text-xs uppercase tracking-[0.2em] text-text-muted">
              Available to read online, with new editions released every quarter.
            </p>
          </Reveal>
        </div>
      </Container>
    </section>
  )
}
